__turbopack_context__.v({
  "hamburgerWrapper": "hamburger-module__PTrJaq__hamburgerWrapper",
});
